
/* injects from baggage-loader */

/**
 * Создан для замены useStaticFilesLoader в siter.config.js.
 * Являяется оберткой, используя тот же самый StaticFilesLoader, с теми же настройками, только через сервис $translateStaticFilesLoader.
 * Объединяет переводы из файтов locale_{lang}.json с переводами из window.justclick.messages
 *
 * @see https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translateStaticFilesLoader
 */
angular.module('siter.io').factory('TranslationLoader', ["$q", "$translateStaticFilesLoader", ($q, $translateStaticFilesLoader) => {
    return function (options) {
        const deferred = $q.defer();
        let translations = {};

        if (typeof window.justclick.messages !== 'undefined') {
            translations = window.justclick.messages;
        }

        $translateStaticFilesLoader(options)
            .then(function (data) {
                Object.assign(data, translations);

                deferred.resolve(data);
            });

        return deferred.promise;
    };
}]);



// WEBPACK FOOTER //
// ./src/app/common/services/translationLoader.service.js